import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { AnalyticsEventLocation } from 'services/analytics/entities';
import { useAddToLibrary, useRemoveFromLibrary } from 'services/hooks';
import { VegaSong } from 'services/store/ai/types';
import { selectSong } from 'services/store/newSongs/selectors';

const useLibraryTrack = ({ id: songId }: VegaSong) => {
  const song = useSelector(selectSong(songId));

  const { addSongToLibrary } = useAddToLibrary({
    songId,
    location: AnalyticsEventLocation.AI_MUSIC_GENERATOR,
  });

  const { removeSongFromLibrary } = useRemoveFromLibrary({
    songId,
    location: AnalyticsEventLocation.AI_MUSIC_GENERATOR,
  });

  const isInLibrary = useMemo(() => song?.isInLibrary || false, [song]);

  return {
    isInLibrary,
    addToLibrary: addSongToLibrary,
    removeFromLibrary: removeSongFromLibrary,
  };
};

export default useLibraryTrack;
